var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconRoundedRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 22,
    rx: 5,
    fill: "#ffffff",
    stroke: "#b99750"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L9 17.1962L9 6.80385L18 12Z",
    fill: "#b99750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconRoundedRectangle);
export default __webpack_public_path__ + "static/media/play-icon-rounded-rectangle.b140ccc0e9404872976a0268910f028c.svg";
export { ForwardRef as ReactComponent };